import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../AuthContext'; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';  
import { BASE_URL } from '../Config';  // Correct path for Config

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // State to control popup visibility
  const [otp, setOtp] = useState('');
  const [otpLoading, setOtpLoading] = useState(false); // State to manage OTP verification loading
  const [msisdn, setMsisdn] = useState(''); // State to store MSISDN for OTP verification
  const [userRole, setUserRole] = useState(''); // State to store userRole for role-specific navigation

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert('Please enter both email and password.');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}Retail_Login`, {
        email,
        password
      }, {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        }
      });

      if (response.data.responseCode === "0000") {
        const userData = response.data;
        console.log(userData)

        // Save user data in sessionStorage
        sessionStorage.setItem('user', JSON.stringify({
          userId: userData.userId,
          name: userData.name,
          email: userData.email,
          userRole: userData.userRole,
          companyId: userData.companyId,
          companyName: userData.companyName,

        }));

        login(userData);

        setUserRole(userData.userRole); // Set userRole from response

        // Check the userRole and navigate accordingly
        if (userData.userRole === "Agent") {
          navigate('/Sales/Sales');
        } 
        // else if (userData.userRole === "SuperAgent") {
        //   navigate('/SearchCustomerNo');
        // }
        else if (userData.userRole === "JazzCash") {
          navigate('/Dashboard'); 
        } 
        else if (userData.userRole === "Supervisor") {
          navigate('/Supervisor/Supervisor_Dashboard');
        } 
        else if (userData.userRole === "Admin") {
          navigate('/Admin/Admin_Dashboard');
        } 
         else if (userData.userRole === "Company") {
          navigate('/Company/Company_Dashboard');
        } 
        else if (userData.userRole === "Finance") {
          const phoneNumber = "03125760562"; 
          const network = "zong";
          setShowPopup(true);
          sendSmsOtp(phoneNumber, network); 
        } 
        else if (userData.userRole === "CustomerService") {
          const phoneNumber = "03009739388";
          const network = "zong"; 
          setShowPopup(true);
          sendSmsOtp(phoneNumber, network); 
        } else {
          navigate('/');
        }
      } 
      else {
        alert('Login failed. Please check your credentials and try again.');
      }
    } catch (error) {
      // console.error('Login error:', error);
      alert('An error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Function to send SMS OTP
  const sendSmsOtp = async (phoneNumber, network) => {
    try {
      setOtpLoading(true);
      setMsisdn(phoneNumber); // Set the msisdn when sending OTP
      
      const response = await axios.post('https://ChargingAPI.webddocsystems.com/SendSms', {
        msisdn: phoneNumber, // Send the MSISDN
        operatorName: network, // Send the operator name (zong or jazz)
        text: " ", // Text for OTP (can be a template message)
        purpose: "login"
      }, {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        }
      });
  
      // console.log("SMS sent:", response);
      // Proceed to OTP input popup after SMS is sent
    } catch (error) {
      // console.error('SMS sending failed:', error);
      alert('Failed to send OTP. Please try again.');
    } finally {
      setOtpLoading(false);
    }
  };

  // Function to handle OTP verification
  const handleOtpVerification = async () => {
    if (!otp || otp.length !== 6) {
      alert('Please enter a valid 6-digit OTP.');
      return;
    }
  
    try {
      setOtpLoading(true);
  
      // Use the msisdn value that was set when sending the OTP
      const response = await axios.post('https://ChargingAPI.webddocsystems.com/VerifyOtp', {
        msisdn: msisdn, // msisdn is now properly set and will be used for verification
        otpCode: otp
      }, {
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
        }
      });
  
      if (response.data.responseCode === "0000") {
        alert('OTP verified successfully!');
        setShowPopup(false); 

        if (userRole === "CustomerService") {
          navigate('/Reversal'); 
        } else if (userRole === "Finance") {
          navigate('/Report'); 
        }
      } else {
        alert('Invalid OTP. Please try again.');
      }
    } catch (error) {
      // console.error('OTP verification failed:', error);
      alert('Failed to verify OTP. Please try again.');
    } finally {
      setOtpLoading(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center">
      <div className="col-md-6 col-lg-4">
        <div className="card shadow-sm">
          <div className="card-body">
            <div className="text-center mb-4">
              <img src="../Webdoc_Logo.webp" alt="logo" style={{ width: '185px' }} />
              <h4 className="mt-3">Login to Your Account</h4>
            </div>

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email Address</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3 position-relative">
                <label htmlFor="password" className="form-label">Password</label>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'} position-absolute top-50 end-0 translate-middle-y pe-3 mt-3`}
                  style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}></i>
              </div>

              <div className="d-grid gap-2 my-4">
                <button className="btn btn-primary" type="submit" disabled={loading}>
                  {loading ? 'Logging in...' : 'Sign In'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* OTP Popup */}
      {showPopup && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">OTP Verification</h5>
                <button type="button" className="btn-close" onClick={() => setShowPopup(false)}></button>
              </div>
              <div className="modal-body">
                <div>
                  <label htmlFor="otp">Enter OTP</label>
                  <input
                    type="text"
                    className="form-control"
                    id="otp"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                  />
                </div>
                <div className="mt-3 text-center">
                  <button
                    className="btn btn-primary"
                    onClick={handleOtpVerification}
                    disabled={otpLoading}
                  >
                    {otpLoading ? 'Verifying...' : 'Verify OTP'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
